
<template>
  <div
    id="chat-app"
    class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden"
  >
    <vs-sidebar
      class="items-no-padding overflow-visible chat-messenger-sidebar"
      parent="#chat-app"
      :click-not-close="clickNotClose"
      :hidden-background="clickNotClose"
      v-model="isChatSidebarActive"
      id="chat-list-sidebar"
    >
      <!-- USER PROFILE SIDEBAR -->
      <user-profile
        :active="activeProfileSidebar"
        :conv-id="activeChatUser"
        conversationType="chat"
        :defaultSearchQuery="
          !activeConversation
            ? ''
            : activeConversation.messengerUser.firstName +
              ' ' +
              activeConversation.messengerUser.lastName
        "
        class="user-profile-container"
        :isLoggedInUser="isLoggedInUserProfileView"
        @closeProfileSidebar="closeProfileSidebar"
      ></user-profile>

      <div
        class="flex p-4 flex-col transition-shadow duration-200"
        :class="{ 'shadow-lg': showFilters }"
      >
        <div class="flex flex-row justify-between">
          <!-- <div class="relative inline-flex">
            <vs-avatar
              v-if="true"
              class="m-0 border-2 border-solid border-white"
              src="http://cdn.leoh.io/images/base_zero/image_233.jpg"
              size="40px"
            />
            <div
              class="
                h-3
                w-3
                border-white border border-solid
                rounded-full
                absolute
                right-0
                bottom-0
                bg-success
              "
            ></div>
          </div> -->
          <div
            class="flex justify-center items-center mr-2 cursor-pointer"
            @click="isMuted = !isMuted"
          >
            <feather-icon
              :icon="isMuted ? 'BellOffIcon' : 'BellIcon'"
              svgClasses="w-5 h-5"
            />
          </div>
          <vs-input
            icon-no-border
            icon="icon-search"
            icon-pack="feather"
            class="w-full mr-5 input-rounded-full"
            placeholder="Search for conversation"
            v-model="searchQuery"
          />
          <div class="self-center">
            <div
              class="flex text-sm cursor-pointer"
              @click="showFilters = !showFilters"
            >
              <div class="whitespace-no-wrap">
                <b
                  >{{ numAppliedFilters }}
                  {{ numAppliedFilters === 1 ? "Filter" : "Filters" }}&nbsp;</b
                >
              </div>
              <feather-icon
                :icon="showFilters ? 'ChevronUpIcon' : 'ChevronDownIcon'"
                svgClasses="w-4 h-4"
              />
            </div>
          </div>
        </div>
        <!-- filters -->
        <div
          class="flex filter-wrapper"
          :class="{ 'hide-filters': !showFilters }"
        >
          <div class="pt-4">
            <vs-row class="items-center py-1">
              <vs-col vs-w="3"> Show only: </vs-col>
              <vs-col vs-w="9">
                <venue-selector
                  v-model="filterVenue"
                  :deactivated="!!filterNegativeVenue"
                  :multiple="false"
                  placeholder="Select venue"
                />
              </vs-col>
            </vs-row>
            <vs-row class="items-center py-1">
              <vs-col vs-w="3"> Show all but: </vs-col>
              <vs-col vs-w="9">
                <venue-selector
                  :deactivated="!!filterVenue"
                  v-model="filterNegativeVenue"
                  :multiple="false"
                  placeholder="Select venue"
                />
              </vs-col>
            </vs-row>
            <vs-row class="items-center py-1">
              <vs-col vs-w="3"> Assigned: </vs-col>
              <vs-col vs-w="9">
                <vs-select v-model="filterAssigned" class="w-full">
                  <vs-select-item
                    :key="index"
                    :value="item.value"
                    :text="item.text"
                    v-for="(item, index) in filterAssignedOptions"
                  />
                </vs-select>
              </vs-col>
            </vs-row>
            <vs-row class="items-center py-1">
              <vs-col vs-w="3"> Status: </vs-col>
              <vs-col vs-w="9">
                <vs-select v-model="filterStatus" class="w-full">
                  <vs-select-item
                    :key="index"
                    :value="item.value"
                    :text="item.text"
                    v-for="(item, index) in filterStatusOptions"
                  />
                </vs-select>
              </vs-col>
            </vs-row>
          </div>
        </div>
      </div>

      <vs-divider class="d-theme-border-grey-light m-0" />
      <component
        :is="scrollbarTag"
        class="chat-scroll-area pt-4"
        :settings="settings"
        :key="$vs.rtl"
      >
        <!-- ACTIVE CHATS LIST -->
        <div class="chat__chats-list mb-8">
          <!-- <h3 class="text-primary mb-5 px-4">Chats</h3> -->
          <ul class="chat__active-chats bordered-items">
            <li
              class="cursor-pointer"
              v-for="(conv, index) in filteredConversations"
              :key="index"
              @click="updateActiveConversation(conv.id)"
            >
              <chat-conversation
                showLastMsg
                :conversation="conv"
                :user="conv.messengerUser"
                :lastMessage="lastMessage(conv.id)"
                :isActiveChatUser="isActiveConversation(conv.id)"
              ></chat-conversation>
            </li>
          </ul>
        </div>
      </component>
    </vs-sidebar>

    <!-- RIGHT COLUMN -->
    <div
      class="chat__bg no-scroll-content chat-content-area border border-solid d-theme-border-grey-light border-t-0 border-r-0 border-b-0"
      :class="{
        'sidebar-spacer--wide': clickNotClose,
        'flex items-center justify-center': activeChatUser === null,
      }"
    >
      <template v-if="activeChatUser">
        <div class="chat__navbar">
          <chat-navbar
            :isSidebarCollapsed="!clickNotClose"
            :conv-id="activeChatUser"
            :isPinnedProp="isChatPinned"
            @openContactsSidebar="toggleChatSidebar(true)"
            @showProfileSidebar="showProfileSidebar"
            @toggleIsChatPinned="toggleIsChatPinned"
          ></chat-navbar>
        </div>
        <component
          :is="scrollbarTag"
          class="chat-content-scroll-area border border-solid d-theme-border-grey-light"
          :settings="settings"
          ref="chatLogPS"
          :key="$vs.rtl"
        >
          <div class="chat__log" ref="chatLog">
            <chat-log
              :userId="activeChatUser"
              v-if="activeChatUser"
              :is-sending="awaitingConfirmation"
            ></chat-log>
          </div>
        </component>

        <!-- Input and send -->
        <send-area
          type="chat"
          :activeConversation="activeConversation"
          @onSendMessage="sendMsg"
          ref="sendArea"
        />
      </template>
      <template v-else>
        <div class="flex flex-col items-center">
          <feather-icon
            icon="MessageSquareIcon"
            class="mb-4 bg-white p-8 shadow-md rounded-full"
            svgClasses="w-16 h-16"
          ></feather-icon>
          <h4 class="py-2 px-4 bg-white shadow-md rounded-full">
            Click a conversation to begin chatting
          </h4>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import ChatConversation from "./ChatConversation.vue";
import ChatLog from "./ChatLog.vue";
import ChatNavbar from "./ChatNavbar.vue";
import UserProfile from "../Components/UserProfileSidebar.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

import { mapGetters } from "vuex";

import FeatherIcon from "../../../../../components/FeatherIcon.vue";

import VenueSelector from "@/components/VenueSelector.vue";
import SendArea from "../Components/SendArea.vue";

import notificationSound from "@/assets/notification_sound.wav";

export default {
  data() {
    return {
      ws: null,
      active: true,
      isHidden: false,
      searchContact: "",
      activeProfileSidebar: false,
      activeChatUser: null,
      userProfileId: -1,
      isChatPinned: false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.7,
      },
      clickNotClose: true,
      isChatSidebarActive: true,
      isLoggedInUserProfileView: false,

      isMuted: false,

      searchQuery: "",

      showFilters: false,
      filterVenue: null,
      filterNegativeVenue: null,
      filterAssigned: 0,
      filterStatus: 0,
      filterAssignedOptions: [
        { text: "Any", value: 0 },
        { text: "Unassigned", value: 1 },
        { text: "Assigned", value: 2 },
        { text: "Assigned to me", value: 3 },
      ],
      filterStatusOptions: [
        { text: "Any", value: 0 },
        { text: "OPEN", value: 1 },
        { text: "CLOSED", value: 2 },
      ],
    };
  },
  watch: {
    windowWidth() {
      this.setSidebarWidth();
    },
    latestMessageNum() {
      if (!this.isMuted) this.playNotificationSound();
    },
  },
  computed: {
    ...mapGetters({
      conversations: "chat/conversations",
      activeConversation: "chat/activeConversation",
      activeConversationId: "chat/activeConversationId",
      awaitingConfirmation: "chat/awaitingConfirmation",
      latestMessageNum: "chat/latestMessageNum",
      userId: "users/userId",
      venues: "venues/venues",
    }),
    filteredConversations() {
      let result = this.conversations;
      // Venue
      if (this.filterVenue != null)
        result = result.filter((e) => e.venueId === this.filterVenue);
      else if (this.filterNegativeVenue != null)
        result = result.filter((e) => e.venueId !== this.filterNegativeVenue);

      // Assigned, Unassigned, Me
      if (this.filterAssigned == 1)
        result = result.filter((e) => e.assignee === null);
      else if (this.filterAssigned == 2)
        result = result.filter((e) => e.assignee !== null);
      else if (this.filterAssigned == 3)
        result = result.filter(
          (e) => e.assignee && e.assignee.userId === this.userId
        );

      // Status
      if (this.filterStatus == 1)
        result = result.filter((e) => e.status === "OPEN");
      else if (this.filterStatus == 2)
        result = result.filter((e) => e.status === "CLOSED");

      // Search
      if (this.searchQuery != "")
        result = result.filter((e) => {
          const msgUser = e.messengerUser;
          const fullName = `${msgUser.firstName} ${msgUser.lastName}`;

          const qLower = this.searchQuery.toLowerCase();

          const nameMatch = fullName.toLowerCase().includes(qLower);
          const messageMatch = e.messages.some((message) =>
            message.text ? message.text.toLowerCase().includes(qLower) : false
          );
          const topicMatch = e.topics.some((topic) =>
            topic.topic.toLowerCase().includes(qLower)
          );

          return nameMatch || messageMatch || topicMatch;
        });

      // Sort by latest message timestamp and by status
      result.sort((a, b) => {
        const aMessage = this.lastMessage(a.id);
        const bMessage = this.lastMessage(b.id);

        if (a.status == "CLOSED" && b.status != "CLOSED") return 1;
        if (a.status != "CLOSED" && b.status == "CLOSED") return -1;
        return aMessage.timestamp < bMessage.timestamp ? 1 : -1;
      });

      return result;
    },
    numAppliedFilters() {
      let num = 0;
      if (this.filterVenue != null) num++;
      if (this.filterAssigned != 0) num++;
      if (this.filterStatus != 0) num++;
      return num;
    },
    lastMessage() {
      return (convId) =>
        this.$store.getters["chat/conversationLastMessage"](convId);
    },
    // searchQuery: {
    //   get() {
    //     return ""; //return this.$store.state.chat.chatSearchQuery;
    //   },
    //   set(val) {
    //     //this.$store.dispatch("chat/setChatSearchQuery", val);
    //   },
    // },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
    isActiveConversation() {
      return (userId) => userId === this.activeConversationId;
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
  },
  methods: {
    closeProfileSidebar(value) {
      this.activeProfileSidebar = value;
    },
    updateActiveConversation(contactId) {
      this.activeChatUser = contactId;
      this.$store.commit("chat/setActiveConversation", contactId);

      this.toggleChatSidebar();
      // this.typedMessage = "";
    },
    showProfileSidebar(userId, openOnLeft = false) {
      this.userProfileId = userId;
      this.isLoggedInUserProfileView = openOnLeft;
      this.activeProfileSidebar = !this.activeProfileSidebar;
    },
    toggleIsChatPinned(value) {
      this.isChatPinned = value;
    },
    setSidebarWidth() {
      if (this.windowWidth < 1200) {
        this.isChatSidebarActive = this.clickNotClose = false;
      } else {
        this.isChatSidebarActive = this.clickNotClose = true;
      }
    },
    toggleChatSidebar(value = false) {
      if (!value && this.clickNotClose) return;
      this.isChatSidebarActive = value;
    },

    async sendMsg(typedMessage) {
      const payload = {
        venueId: this.$store.getters["chat/activeConversation"].venueId,
        psid: this.activeChatUser,
        text: typedMessage,
      };
      await this.$store.dispatch("chat/sendMessage", payload);

      // Scroll down
      const scroll_el = this.$refs.chatLogPS.$el || this.$refs.chatLogPS;
      scroll_el.scrollTop = this.$refs.chatLog.scrollHeight;

      // Clear send area
      this.$refs.sendArea.messageSent();
    },

    playNotificationSound() {
      var audio = new Audio(notificationSound);
      audio.play();
    },
  },
  components: {
    VuePerfectScrollbar,
    ChatConversation,
    UserProfile,
    ChatNavbar,
    ChatLog,
    FeatherIcon,
    VenueSelector,
    SendArea,
  },
  async created() {
    this.setSidebarWidth();
  },
  beforeDestroy() {
    this.ws.close();
  },
  async mounted() {
    //this.$store.dispatch("chat/setChatSearchQuery", "");
    this.$vs.loading();
    this.$store.dispatch(
      "chat/setChatVenues",
      this.venues.map((e) => e.venueId)
    );
    await this.$store.dispatch("chat/getAll");
    await this.$store.dispatch("venues/getGuestRelationUsers"); // Get all guest relation users that can be assigned

    if (!this.ws) {
      await this.$store.dispatch("chat/negotiatePubSub");
      const wssUrl = this.$store.getters["chat/pubSubUrl"];

      this.ws = new WebSocket(wssUrl);
      this.ws.onopen = () =>
        console.log("Connected to Messenger PubSub server");

      this.ws.onclose = () =>
        console.log("Disconnected from Messenger PubSub server");

      this.ws.onmessage = (event) => {
        this.$store.dispatch("chat/handleSocketMessage", {
          dto: JSON.parse(event.data),
          filter: this.filterVenue,
          negativeFilter: this.filterNegativeVenue,
        });
      };
    }

    this.$vs.loading.close();
  },
};
</script>


<style lang="scss">
@import "@/assets/scss/vuexy/apps/chat.scss";
</style>

<style lang="scss">
.chat-messenger-sidebar {
  .vs-sidebar {
    left: 0 !important;
  }
}

.content-wrapper {
  position: relative;
  height: 1px;

  .router-view {
    height: 100%;
    .router-content {
      height: 100%;
      .content-area__content {
        height: 100%;
      }
    }
  }
}

#chat-app {
  height: 100%;

  .chat__bg {
    height: 100%;
  }
}

.filter-wrapper {
  transition: max-height 0.2s ease-out;
  overflow: visible;
  transform-origin: top;
  max-height: 200px;

  &.hide-filters {
    max-height: 0;
    overflow: hidden;
  }
}
</style>